import { Button, styled } from '@mui/material'

export const BotaoConfirmar = styled( Button )`
  font-size: 18px;
  color: white;
  background-color: #DC7B3F;
  border-radius: 30px;
  padding-left: 25px;
  padding-right: 25px;
`;